
// MOLOTOF
// CHOKLET LAB BUILDER

var chokletBuilder = {
  elements:[],
  addons:[],
  totPrice:0
}
var step1;

$(document).ready(function(){
  media = $(".lil-choklet-lab-builder .media");
  step1 = $(".lil-choklet-lab-builder .step-1");
  step2 = $(".lil-choklet-lab-builder .step-2");


  $(".lil-choklet-lab-builder .btn-move").on("click", function(event){
    var product = $(event.currentTarget).parent();

    var data = {}
    data.product = product;
    data.productType = product.attr("data-type");
    data.variantId = product.attr("data-variant-id");
    data.price = product.attr("data-price");
    
    var direction = Number($(event.currentTarget).attr("data-direction"));
    var max = Number($(event.currentTarget).attr("data-max"));
    var currentQta = Number(product.find(".cb-num").html());

    if(direction){
      //add
      if(currentQta < max){
        cbAddElement(data); 
      }
    } else {
      //remove
      cbRemoveElement(data);
    }
    
    event.stopPropagation();
  });
})

function cbSelectPreset(element){
  const preset = $(element);

  step1.find(".sel").removeClass("active");
  preset.addClass("active");

  step1.find(".step-btn").addClass("active");
  
  chokletBuilder.tit = preset.attr("data-tit");
  chokletBuilder.descr = preset.attr("data-descr");
  chokletBuilder.numElements = Number(preset.attr("data-num-elements"));
  chokletBuilder.numAddOns = Number(preset.attr("data-num-addons"));
  chokletBuilder.btnText = preset.attr("data-btn-text");
  chokletBuilder.btnTextSuggest = preset.attr("data-btn-text-suggest");
}

function cbGoBack(){
  chokletBuilder = {
    elements:[],
    addons:[],
    totPrice:0
  };
  media.find(".background-images").removeClass("active");
  media.find(".background-images .image").remove();
  media.find(".background-blank").removeClass("active");
  step1.find(".sel").removeClass("active");
  step1.find(".step-btn").removeClass("active");  
  step2.find(".sel-prod").removeClass("active");
  step2.addClass("closed");
}

function cbGoToStep2(){
  if(localStorage.getItem("lil-customer-country") == "GB"){
    $(".GB-false").hide();
  } else {
    $(".IT-false").hide();
  }

  // load text field
  step2.find(".step-head .tit").html(chokletBuilder.tit);
  step2.find(".step-head .descr").html(chokletBuilder.descr);
  step2.find(".step-head .price").html(currencyFormatMoney(0, window.theme.moneyFormat));

  generateBtnConfirmText();

  media.find(".background-blank").addClass("active");

  step2.find("*[data-type='yellow']").show();
  step2.find("*[data-type='white']").hide();
  step2.find("*[data-type='addons']").hide();

  $(".type-selector .ts").removeClass("active");
  $(".type-selector .ts-1").addClass("active");
  
  step2.removeClass("closed");
}

function cbFilterType(element, type){
  $(".type-selector .ts").removeClass("active");
  $(element).addClass("active");

  step2.find(".sel-prod").hide();
  step2.find("*[data-type='"+type+"']").show();
}


function generateBtnConfirmText(){
  // load btn text
  var btnText = "";
  var cssClass = "";
  const insertedNumElements = chokletBuilder.elements.length;
  const insertedNumAddons = chokletBuilder.addons.length;
  
  if(chokletBuilder.numElements == 0 && chokletBuilder.numAddOns == 0){
    btnText = chokletBuilder.btnText;

    if(insertedNumElements > 0 || insertedNumAddons > 0){
      btnText = "Confirm and add to cart <span>"+chokletBuilder.btnTextSuggest+"</span>";
      cssClass = "active"; 
    }
    
    step2.find(".step-button .step-btn").html(btnText);
    
    step2.find(".step-button .step-btn").removeClass("active");
    step2.find(".step-button .step-btn").addClass(cssClass);
    return;
  }


  if(chokletBuilder.numElements > 0 || chokletBuilder.numAddOns > 0){
    btnText = chokletBuilder.btnText;

    btnText = "Add " + (chokletBuilder.numElements - insertedNumElements) + " ELEMENTS + " + (chokletBuilder.numAddOns - insertedNumAddons) + " ADDONS";

    if(insertedNumElements < chokletBuilder.numElements && insertedNumAddons >= chokletBuilder.numAddOns){
      btnText = "Add " + (chokletBuilder.numElements - insertedNumElements) + " ELEMENTS";
    }
    
    if(insertedNumElements >= chokletBuilder.numElements && insertedNumAddons < chokletBuilder.numAddOns){
      btnText = "Add " + (chokletBuilder.numAddOns - insertedNumAddons) + " ADDONS";
    }
    
    if(insertedNumElements >= chokletBuilder.numElements && insertedNumAddons >= chokletBuilder.numAddOns){
      btnText = "Confirm and add to cart";
      cssClass = "active"; 
    }
    
    step2.find(".step-button .step-btn").html(btnText);
    
    step2.find(".step-button .step-btn").removeClass("active");
    step2.find(".step-button .step-btn").addClass(cssClass);
    return;
  }
}


function cbSelectProduct(element){
  var product = $(element);
  var productType = product.attr("data-type");
  var variantId = product.attr("data-variant-id");
  var price = product.attr("data-price");

  if(!product.hasClass("active")){
  //if(1 == 1){
    var productData = {
      id: variantId,
      form_type: "product",
      utf8: "✓",
      quantity: 1,
      random: Math.floor(Math.random()*1000000)
    }

    if(productType == "addons"){
      //addons
      chokletBuilder.addons.push(productData);
    } else {
      //elements
      chokletBuilder.elements.push(productData);
    }

    chokletBuilder.totPrice += Number(price); 
    
    //load image in background box
    media.find(".background-images .images-box").append(product.find(".image")[0].outerHTML);

    product.addClass("active");
  } else {
    

  
  }

  
}


function cbAddElement(data){
  var productData = {
    id: data.variantId,
    form_type: "product",
    utf8: "✓",
    quantity: 1,
    random: Math.floor(Math.random()*1000000)
  }

  if(data.productType == "addons"){
    //addons
    chokletBuilder.addons.push(productData);
  } else {
    //elements
    chokletBuilder.elements.push(productData);
  }

  chokletBuilder.totPrice += Number(data.price); 

  //load image in background box
  media.find(".background-images .images-box").append(data.product.find(".image")[0].outerHTML);
  media.find(".background-images .images-box .image").last().attr("data-id", productData.random);

  cbEndAction();
}

function cbRemoveElement(data){
  //remove product from session
  if(data.productType == "addons"){
    //addons
    $.each(chokletBuilder.addons, function(i, el){
        if(chokletBuilder.addons[i].id === data.variantId) {
          media.find(".background-images .images-box *[data-id='"+el.random+"']").remove();
          chokletBuilder.addons.splice(i,1);
          return false;
        }
    });
  } else {
    //elements
    $.each(chokletBuilder.elements, function(i, el){
        if(chokletBuilder.elements[i].id === data.variantId) {
          media.find(".background-images .images-box *[data-id='"+el.random+"']").remove();
          chokletBuilder.elements.splice(i,1);
          return false;
        }
    });
  }

  chokletBuilder.totPrice -= Number(data.price);
  cbEndAction();
}


function cbEndAction(){
  const insertedNumElements = chokletBuilder.elements.length;
  const insertedNumAddons = chokletBuilder.addons.length;
  
  if((insertedNumElements + insertedNumAddons) > 0){
    media.find(".background-images").addClass("active");
  } else {
    media.find(".background-images").removeClass("active");
  }

  step2.find(".sel").removeClass("active");
  step2.find(".sel .cb-num").html(0);
  
  $.each(chokletBuilder.elements, function(i, el){
    var sel = step2.find(".sel[data-variant-id='"+el.id+"']");
    sel.addClass("active");
    sel.find(".cb-num").html(Number(sel.find(".cb-num").html()) + 1);
  });

  $.each(chokletBuilder.addons, function(i, el){
    var sel = step2.find(".sel[data-variant-id='"+el.id+"']");
    sel.addClass("active");
    sel.find(".cb-num").html(Number(sel.find(".cb-num").html()) + 1);
  });
  
  step2.find(".step-head .price").html(currencyFormatMoney(chokletBuilder.totPrice, window.theme.moneyFormat));
  generateBtnConfirmText();
}


function cbConfirmAddToCart(){
  const data = {
    items: chokletBuilder.elements.concat(chokletBuilder.addons)
  }
  
  fetch("".concat(window.routes.cartAddUrl, ".js"), {
    body: JSON.stringify(data),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

    }
  }).then(function (response) {
    if (response.ok) {
      window.location.replace("/cart");
    } else {
      response.json().then(function (content) {
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content['description'];
        setTimeout(function () { errorMessageElement.remove(); }, 2500);
      });
    }
  });
  event.preventDefault();
}


function currencyFormatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value).replace(',00', '');
  } else {
    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }
}


//premade
function cbSelectPremade(element){
  cbGoBack();

  step1.find(".sel[data-num-elements='0']").click();
  cbGoToStep2();

  var variants = $(element).find("input").val().split(";");
  
  $.each(variants, function(i, variant){
    if(variant.length < 1){ return; }
    step2.find(".sel[data-variant-id='"+variant+"'] .add").click();
  });

  $("html, body").animate({ scrollTop: 0 }, 1000);
}